const STOCK_LOGO_BASE_URL = "https://financialmodelingprep.com/image-stock";

export function getStockLogoUrl(symbol: string): string {
  return `${STOCK_LOGO_BASE_URL}/${encodeURIComponent(symbol.trim().toUpperCase())}.png`;
}
